/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import qs from 'qs';
import { useHistory } from 'react-router-dom';
import Highcharts from 'highcharts';
import { Box, CircularProgress } from '@material-ui/core';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HighchartsReact from 'highcharts-react-official';
import { formatQuantitiesByStates } from '../utils';
import ExportCsvButton from './utils/ExportCsvButton';
import { exportToCsv, exportToExcel } from './utils/csvExport';

const StateChart = ({ quantitiesByStates, loadingQuantitiesByStates }) => {
  const data = formatQuantitiesByStates(quantitiesByStates);
  const history = useHistory();
  const options = {
    chart: {
      backgroundColor: 'transparent',
      type: 'column',
      height: 250
    },
    title: {
      text: ''
    },
    xAxis: {
      type: 'category',
      labels: {
        style: {
          color: '#262626',
          fontSize: 16,
          fontWeight: 400,
          marginTop: '100px'
        }
      }
    },
    yAxis: {
      min: 0,
      labels: {
        style: {
          color: '#777777'
        }
      },
      title: {
        text: ''
      }
    },
    tooltip: {
      pointFormat:
        '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
        '<td style="padding:0"><b>{point.y}</b></td></tr>',
      footerFormat: '</table>',
      useHTML: true
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        borderRadius: 8
      },
      series: {
        color: '#4C76BB',
        pointWidth: 26,
        cursor: 'pointer',
        point: {
          events: {
            click() {
              history.push({
                pathname: '/sent-by-me',
                search: qs.stringify({
                  states: [data[this.category].previousName],
                  isInCustomerOperation: false,
                  maximumShippingDate: true
                })
              });
            }
          }
        }
      }
    },
    credits: {
      enabled: false
    },
    legend: {
      enabled: false
    },
    series: [
      {
        name: 'État',
        data: data.map(d => d.hightchartFormat)
      }
    ]
  };

  const getExportData = () => {
    const columns = ['État', 'Quantité'];
    const rows = data.map(d => [d.hightchartFormat[0], d.hightchartFormat[1]]);
    return { columns, rows };
  };

  return (
    <div>
      <Box display="flex" justifyContent="flex-end" mb={1}>
        <ExportCsvButton
          onClick={() => { const { columns, rows } = getExportData(); exportToCsv('commandes_par_etat', columns, rows); }}
          onExcelClick={() => { const { columns, rows } = getExportData(); exportToExcel('commandes_par_etat', columns, rows); }}
        />
      </Box>
      {loadingQuantitiesByStates ? (
        <Box display="flex" justifyContent="center" p={20}>
          <CircularProgress size={60} />
        </Box>
      ) : (
        <HighchartsReact highcharts={Highcharts} options={options} />
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  quantitiesByStates: state.dashboard.quantitiesByStates,
  loadingQuantitiesByStates: state.dashboard.loadingQuantitiesByStates
});

StateChart.propTypes = {
  quantitiesByStates: PropTypes.array,
  loadingQuantitiesByStates: PropTypes.bool
};

export default connect(mapStateToProps)(StateChart);
